import React from 'react';

const enum Transitions {
  SHOW = 'enter-active',
  HIDE = 'exit-active',
}

interface IPageTransitionProps {
  children: React.ReactNode;
  timeout: number;
  classNames: string;
}

interface IPageTransitionState {
  currentComponent: React.ReactNode;
  nextComponent: React.ReactNode;
  transitionState: Transitions;
}

class PageTransition extends React.Component<
  IPageTransitionProps,
  IPageTransitionState
> {
  animationTimer: number;

  constructor(props) {
    super(props);

    this.state = {
      currentComponent: props.children,
      nextComponent: null,
      transitionState: null,
    };

    this.animationTimer = null;
  }

  componentDidUpdate() {
    this.swapComponents();
  }

  componentWillUnmount() {
    window.clearTimeout(this.animationTimer);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.nextComponent === props.children) {
      return null;
    }

    return {
      nextComponent: props.children,
      transitionState: state.nextComponent ? Transitions.HIDE : null,
    };
  }

  swapComponents() {
    const isComponentsDifferent =
      this.state.currentComponent !== this.props.children;

    if (this.state.nextComponent && isComponentsDifferent) {
      window.clearTimeout(this.animationTimer);

      this.animationTimer = window.setTimeout(() => {
        this.setState({
          currentComponent: this.state.nextComponent,
          transitionState: Transitions.SHOW,
        });
      }, this.props.timeout);
    }
  }

  getAnimationClassName() {
    return this.state.transitionState
      ? `${this.props.classNames}-${this.state.transitionState}`
      : `${this.props.classNames}-initial`;
  }

  render() {
    return (
      <div className={this.getAnimationClassName()}>
        {this.state.currentComponent}
      </div>
    );
  }
}

export default PageTransition;
